import { render, staticRenderFns } from "./Ujian.vue?vue&type=template&id=a92b8492"
import script from "./Ujian.vue?vue&type=script&lang=js"
export * from "./Ujian.vue?vue&type=script&lang=js"
import style0 from "./Ujian.vue?vue&type=style&index=0&id=a92b8492&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports